type calculateBulletsCountArgs = {
  itemsLength: number;
  slideStep: number;
  pageSize: number;
  loop: boolean;
};

export function calculateBulletsCount({
  itemsLength,
  slideStep,
  pageSize,
  loop
}: calculateBulletsCountArgs) {
  if (!loop && slideStep === 1) {
    return Math.max(itemsLength - pageSize + 1, 1);
  }

  return Math.ceil(itemsLength / slideStep);
}
